import { render } from "./Copyright.vue?vue&type=template&id=1cb44726&scoped=true&ts=true"
import script from "./Copyright.vue?vue&type=script&lang=ts"
export * from "./Copyright.vue?vue&type=script&lang=ts"

import "./Copyright.vue?vue&type=style&index=0&id=1cb44726&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb44726"]])

export default __exports__